export const purchases = {
    products: [
        {
            key: 'osmand-maps',
            value: 'OsmAnd Maps+',
        },
    ],
    subscriptions: [
        {
            key: 'osmand-pro-annual',
            value: 'OsmAnd Pro Annual',
            type: 'pro',
        },
    ],
};
